import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import './metaConversation.css';

/** Cliente só do Instagram com a conta inativa: não há como responder, e o WhatsApp não é o canal dele. */
export const InstagramReconnectNotice: React.FC = () => (
  <div className="meta-composer">
    <div className="meta-window meta-window-closed" role="status">
      <FiAlertCircle size={14} aria-hidden="true" />
      <span>
        <strong>Instagram precisa reconectar.</strong> Este cliente só escreve pelo Instagram. Reconecte em Configurações › Conexões para responder.
      </span>
    </div>
  </div>
);
